const data = [
  {
    id: 1,
    question: 'Layanan apa saja yang tersedia di iTech Service?',
    answer:
      'Kami menyediakan berbagai layanan service perangkat Apple, mulai dari penggantian layar dan baterai hingga penanganan software dan kerusakan hardware lainnya.',
  },
  {
    id: 2,
    question: 'Berapa lama proses perbaikan perangkat?',
    answer: 'Durasi pengerjaan bergantung pada jenis kerusakan perangkat. Sebagian besar proses service dapat diselesaikan dengan cepat sesuai tingkat penanganan yang dibutuhkan.',
  },
  {
    id: 3,
    question: 'Apakah iTech Service menggunakan sparepart original?',
    answer:
      'Kami menggunakan suku cadang berkualitas untuk memastikan performa perangkat tetap optimal setelah proses service dilakukan.',
  },
  {
    id: 4,
    question: 'Apakah tersedia konsultasi sebelum service?',
    answer: 'Ya, kami menyediakan konsultasi gratis untuk membantu Anda memahami kondisi perangkat serta pilihan penanganan yang tersedia sebelum proses service dilakukan.',
  },
];

export default data;
